/*
<summary>
  This functional component "LogoutPopup" provides modal popup that shows logout confirmation message (i.e. Are you sure
  you want logout?).
  Developer:Aashish Singh, Created Date:28-Aug-2022, Last Updated By: Mohammad Saquib Khan, Updated Date: 26-Oct-2022
</summary>
<returns>Returns JSX</returns>
*/

import React, { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './logout-popup.css';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';
import { observer } from 'mobx-react';
import RoutesConstants from '../../../shared-components/routes/routes-constants';
import { useStore } from '../../../contexts/store-provider';
import { useHistory } from 'react-router-dom';
import { formatMessage } from '../../../translations/format-message';
import { getTenantIdFromToken } from '../../../helpers/localstorage-helper';
import Logout from '../../../assets/Images/log-out-icon.png';

interface IProps {
  modalClosed: () => void;
}

const LogoutPopup = (props: IProps) => {
  const history = useHistory();
  const {
    authStore,
    preferencesStore,
    userStore,
    factoryStore,
    processStore,
    aimsPortalStore,
    processTemplateStore,
    factoryScheduleStore,
    productStore,
    teplarPrintStore,
    trayManagementStore,
    groupSettingStore,
    activeTrayManagementStore,
    dashboardStore,
    kishuMarkStore,
    operatorStore,
    userLogsStore,
    dimensionStore,
    checkItemTemplateStore,
    tagReassignStore,
    bomStore,
    correctionControlStore,
    toolManagementStore,
    nonconformityStore,
    toolCheckItemTemplateStore,
    defectiveItemsStore,
    crimpingInspectionRecordStore,
    equipmentInspectionStore,
    userInspectedListStore,
    toolBOMStore,
  } = useStore();
  const { logoutError, logoutSuccess, resetLogout } = authStore;

  const resetStores = () => {
    preferencesStore.resetStore();
    userStore.resetStore();
    factoryStore.resetStore();
    processStore.resetStore();
    aimsPortalStore.resetStore();
    processTemplateStore.resetStore();
    factoryScheduleStore.resetStore();
    productStore.resetStore();
    teplarPrintStore.resetStore();
    trayManagementStore.resetStore();
    groupSettingStore.resetStore();
    activeTrayManagementStore.resetStore();
    dashboardStore.resetStore();
    kishuMarkStore.resetStore();
    operatorStore.resetStore();
    userLogsStore.resetStore();
    dimensionStore.resetStore();
    checkItemTemplateStore.resetStore();
    tagReassignStore.resetStore();
    bomStore.resetStore();
    correctionControlStore.resetStore();
    toolManagementStore.resetStore();
    nonconformityStore.resetStore();
    toolCheckItemTemplateStore.resetStore();
    defectiveItemsStore.resetStore();
    crimpingInspectionRecordStore.resetStore();
    equipmentInspectionStore.resetStore();
    userInspectedListStore.resetStore();
    toolBOMStore.resetStore();
  };

  useEffect(() => {
    if (logoutError) {
      toast.error(formatMessage(logoutError));
      resetLogout();
    }
  }, [logoutError]);

  useEffect(() => {
    if (logoutSuccess) {
      toast.success(formatMessage('logout_successfully'));
      resetLogout();
      history.push(RoutesConstants.Login);
      props.modalClosed();
      resetStores();
    }
  }, [logoutSuccess]);

  const logoutCaller = () => {
    if(operatorStore.isTimerRunning){
      operatorStore.setIsTimerRunning(false);
    }
    authStore.logout();
    // setUpdateTheme("false");
  };

  return (
    <Modal
      show={true}
      centered
      onHide={props.modalClosed}
      dialogClassName="logout-popup"
    >
      {/* <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage id="logout" />
        </Modal.Title>
      </Modal.Header> */}
      <Modal.Body>
        <div className="bootbox-body p-3 pb-0">
          <div className="logout_modal_icon">
            <img
              src={Logout}
              alt="Centra-SD"
              className="img-fluid meritech-logo"
            />
          </div>
          <h3 className="my-3 pt-2">
            <FormattedMessage id="logout_message" />
          </h3>
        </div>
        <div className="row">
          <div className="col-12">
            <Button
              variant="primary"
              onClick={logoutCaller}
              className="btnOkSize my-2"
            >
              <FormattedMessage id="logout" />
            </Button>
          </div>
          <div className="col-12">
            <Button
              variant="light-danger border-0"
              onClick={props.modalClosed}
              className="btnOkSize"
            >
              <FormattedMessage id="cancel" />
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default observer(LogoutPopup);
